import React from "react";

const HighlightWords = ({
  sentence,
  selectedWords,
  handleWordClick,
  submitted,
}) => {
  const renderSentence = () => {
    if (!sentence) {
      return null;
    }

    const regex = /(\S+)(<span[^>]*>.*?<\/span>)/gi;
    let match;
    const words = [];
    let lastIndex = 0;

    while ((match = regex.exec(sentence)) !== null) {
      const incorrectWord = match[1];
      const spanContent = match[2];
      const spanWord = spanContent.replace(/<span[^>]*>(.*?)<\/span>/, "$1");

      const beforeMatch = sentence.slice(lastIndex, match.index).trim();
      if (beforeMatch) {
        words.push(
          ...beforeMatch.split(" ").map((word) => ({
            word,
            isCorrect: false,
          }))
        );
      }

      words.push({ word: incorrectWord, isCorrect: true });
      words.push({ word: spanWord, isCorrect: false });

      lastIndex = regex.lastIndex;
    }

    const afterLastMatch = sentence.slice(lastIndex).trim();
    if (afterLastMatch) {
      words.push(
        ...afterLastMatch.split(" ").map((word) => ({
          word,
          isCorrect: false,
        }))
      );
    }

    return words.map((item, index) => (
      <span
        key={index}
        onClick={() => handleWordClick(index, item.isCorrect)}
        className={`inline-block px-1 cursor-pointer ${
          selectedWords.some((selected) => selected.index === index)
            ? submitted
              ? selectedWords.find((selected) => selected.index === index)
                  .isCorrect
                ? "bg-green-200"
                : "bg-red-200"
              : "bg-blue-200"
            : ""
        } mx-1 mb-2`}
      >
        {item.word}{" "}
      </span>
    ));
  };

  return (
    <div>
      <div className="flex flex-wrap bg-white mx-4 rounded-sm p-4">
        {renderSentence()}
      </div>
    </div>
  );
};

export default HighlightWords;
